"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVideoEssenceProperty = exports.videoEssencePropertyDefinition = void 0;
exports.videoEssencePropertyDefinition = {
    view: {
        label: 'Video essence',
        style: 'video-essence',
    },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'providers',
            argument: [
                'Media Partnerships Video',
                'RBTV Video',
                'RBMN Video',
            ],
        },
    ],
    type: 'service',
    multiple: false,
    name: 'video-essence',
};
const isVideoEssenceProperty = (prop) => {
    return prop.name === exports.videoEssencePropertyDefinition.name;
};
exports.isVideoEssenceProperty = isVideoEssenceProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmlkZW8tZXNzZW5jZS5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3ZpZGVvLWVzc2VuY2UucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSw4QkFBOEIsR0FBRztJQUM1QyxJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsZUFBZTtRQUN0QixLQUFLLEVBQUUsZUFBZTtLQUN2QjtJQUNELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLElBQUk7U0FDZjtRQUNEO1lBQ0UsSUFBSSxFQUFFLFdBQVc7WUFDakIsUUFBUSxFQUFFO2dCQUNSLDBCQUEwQjtnQkFDMUIsWUFBWTtnQkFDWixZQUFZO2FBQ2I7U0FDRjtLQUNGO0lBQ0QsSUFBSSxFQUFFLFNBQVM7SUFDZixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxlQUFlO0NBQ1UsQ0FBQTtBQUkxQixNQUFNLHNCQUFzQixHQUFHLENBQUMsSUFBa0IsRUFBZ0MsRUFBRTtJQUN6RixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssc0NBQThCLENBQUMsSUFBSSxDQUFBO0FBQzFELENBQUMsQ0FBQTtBQUZZLFFBQUEsc0JBQXNCLDBCQUVsQyJ9